import { NumberField, useComputed, type NumberFieldProps } from "@homebound/beam";
import { type ObjectState } from "src/utils/formState";
import { AiProposalValue } from "./AiProposalValue";
import { type AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiNumber, pendingProposedValue } from "./utils/bindAiProposal";

// Derive proposedValue from aiProposal so callers cannot supply a conflicting value.
type AiNumberFieldProps = Omit<NumberFieldProps, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
  /** Saved display value when `value` can contain an uncommitted edit. */
  originalValue?: number | null;
};

/** An unbound AI number field for callers that validate or confirm before committing edits. */
export function AiNumberField(props: AiNumberFieldProps) {
  const { aiProposal, originalValue = props.value, ...others } = props;
  const proposedValue = useComputed(() => pendingProposedValue(aiProposal, parseAiNumber), [aiProposal]);
  return (
    <AiProposalValue aiProposal={aiProposal} originalValue={originalValue}>
      <NumberField {...others} proposedValue={proposedValue} />
    </AiProposalValue>
  );
}
